module.exports = {"privacy":{"ja":"個人情報保護方針","en":"Privacy Policy"},"contact":{"ja":"問い合わせ先","en":"Contact"},"regulation":{"ja":"参加規約・エントリー規約","en":"Virtual Event/Entry Regulation"},"pdf":{"ja":"https://tmf-virtualrun.jp/pdf/virtualrun_regulation_20231219_jp.pdf","en":"https://tmf-virtualrun.jp/pdf/virtualrun_regulation_20231219_en.pdf"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/footer.json
// module id = IdEE
// module chunks = 1